module.exports = __webpack_public_path__ + "static/media/icon_70.93d97dcd.svg";